import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

export async function getAdminDashboardReport() {
  try {
    const fd = new FormData();
    const response = await axios.post(`${apiBaseUrl}aupadmin/get_admin_dash_report`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("getAdminDashboardReport error:", error);
    return { status: false, type: "danger", success: "Failed to load dashboard report" };
  }
}

// 🔹 Get Users List
export async function getUsersList(page_no = 0,type="client") {
  try {
    const fd = new FormData();
    fd.append("page_no", page_no);
    fd.append("type", type);

    const response = await axios.post(`${apiBaseUrl}aupadmin/get_users_list`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("getUsersList error:", error);
    return { status: false, type: "danger", success: "Failed to load user list" };
  }
}

// 🔹 Block / Unblock User
export async function toggleUserStatus(user_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);

    const response = await axios.post(`${apiBaseUrl}aupadmin/block_unblock_user`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("toggleUserStatus error:", error);
    return { status: false, type: "danger", success: "Failed to toggle user status" };
  }
}

// 🔹 Update User Plan
export async function updateUserPlan(user_id, plan_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("plan_id", plan_id);

    const response = await axios.post(`${apiBaseUrl}aupadmin/update_user_plan`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("updateUserPlan error:", error);
    return { status: false, type: "danger", success: "Failed to update user plan" };
  }
}

// 🔹 Delete User
export async function deleteUser(user_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);

    const response = await axios.post(`${apiBaseUrl}aupadmin/delete_user`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("deleteUser error:", error);
    return { status: false, type: "danger", success: "Failed to delete user" };
  }
}

// 🔹 Get User Logs
export async function getUserLogs(user_id, page_no = 0) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("page_no", page_no);

    const response = await axios.post(`${apiBaseUrl}aupadmin/get_user_logs`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("getUserLogs error:", error);
    return { status: false, type: "danger", success: "Failed to load user logs" };
  }
}

// 🔹 Get My Team Report
export async function getMyTeamReport() {
  try {
    const fd = new FormData();
    const response = await axios.post(`${apiBaseUrl}aupadmin/get_my_team_report`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("getMyTeamReport error:", error);
    return { status: false, type: "danger", success: "Failed to load team report" };
  }
}

// 🔹 Get My Team List
export async function getMyTeamList(user_cre_by, page_no = 0, search_key = "") {
  try {
    const fd = new FormData();
    fd.append("user_cre_by", user_cre_by);
    fd.append("page_no", page_no);
    fd.append("search_key", search_key);

    const response = await axios.post(`${apiBaseUrl}aupadmin/get_my_team_list`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("getMyTeamList error:", error);
    return { status: false, type: "danger", success: "Failed to load team list" };
  }
}

// 🔹 Add / Update Team Member
export async function addTeamMember(
  user_id,
  fname,
  lname,
  email,
  mobile,
  status,
  password,
  user_cre_by
) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("fname", fname);
    fd.append("lname", lname);
    fd.append("email", email);
    fd.append("mobile", mobile);
    fd.append("status", status);
    fd.append("password", password);
    fd.append("user_cre_by", user_cre_by);

    const response = await axios.post(`${apiBaseUrl}aupadmin/add_team_member`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("addTeamMember error:", error);
    return { status: false, type: "danger", success: "Failed to save team member" };
  }
  
}
export async function getAdminSettings() {
  try {
    const fd = new FormData();
    const response = await axios.post(`${apiBaseUrl}aupadmin/get_admin_settings`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("getAdminSettings error:", error);
    return { status: false, type: "danger", success: "Failed to load settings" };
  }
}

export async function saveAdminSettings(
  app_name,
  app_logo,
  app_fav,
  date_format,
  from_name,
  from_email,
  smtp_host,
  smtp_port,
  smtp_username,
  smtp_password,
  smtp_secure,
  smtp_status,
  updated_by
) {
  try {
    const fd = new FormData();

    // 🔸 Explicitly append all fields
    fd.append("app_name", app_name);
    fd.append("app_logo", app_logo);
    fd.append("app_fav", app_fav);
    
    fd.append("date_format", date_format);
    fd.append("from_name", from_name);
    fd.append("from_email", from_email);
    fd.append("smtp_host", smtp_host);
    fd.append("smtp_port", smtp_port);
    fd.append("smtp_username", smtp_username);
    fd.append("smtp_password", smtp_password);
    fd.append("smtp_secure", smtp_secure);
    fd.append("smtp_status", smtp_status);
    fd.append("updated_by", updated_by);

    const response = await axios.post(`${apiBaseUrl}aupadmin/save_admin_settings`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("saveAdminSettings error:", error);
    return { status: false, type: "danger", success: "Failed to save settings" };
  }
}

export async function getAiPgSettings() {
  try {
    const fd = new FormData();

    const response = await axios.post(`${apiBaseUrl}aupadmin/get_ai_pg_settings`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getAiPgSettings error:", error);
    return { status: false, type: "danger", success: "Failed to fetch settings" };
  }
}

// 🔹 Save AI + Payment Gateway Settings (Create or Update)
export async function saveAiPgSettings(
  api_key,
  default_model,
  monthly_usage_limit,
  timeout_ms,
  enable_ai_features,
  razorpay_key,
  razorpay_seceret,
  paypal_key,
  paypal_seceret,
  stripe_key,
  updated_by
) {
  try {
    const fd = new FormData();

    // 🔸 Explicitly append all fields
    fd.append("api_key", api_key);
    fd.append("default_model", default_model);
    fd.append("monthly_usage_limit", monthly_usage_limit);
    fd.append("timeout_ms", timeout_ms);
    fd.append("enable_ai_features", enable_ai_features);
    fd.append("razorpay_key", razorpay_key);
    fd.append("razorpay_seceret", razorpay_seceret);
    
    fd.append("paypal_key", paypal_key);
    fd.append("paypal_seceret", paypal_seceret);
    fd.append("stripe_key", stripe_key);
    fd.append("updated_by", updated_by);

    const response = await axios.post(`${apiBaseUrl}aupadmin/save_ai_pg_settings`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("saveAiPgSettings error:", error);
    return { status: false, type: "danger", success: "Failed to save settings" };
  }
}
